import React from 'react';
import {Grid} from '@mui/material';

export default React.memo(Grid);
